import WellSectionWrap from '@bridebook/web/app-shared/components/well-section-wrap/well-section-wrap';
import { IFair } from '@bridebook/web/app-shared/lib/supplier/types';
import FairTile from '@bridebook/web/app-basic/components/supplier/sections/wedding-fairs/tile/fairs-tile';

interface IProps {
  fairs: IFair[];
}

const WeddingFairs = ({ fairs }: IProps) => {
  if (Number(fairs.length) < 1) {
    return null;
  }

  return (
    <WellSectionWrap>
      {fairs.map((fair) => (
        <FairTile key={`wedding-fair-item-${fair.id}`} fair={fair} />
      ))}
    </WellSectionWrap>
  );
};

export default WeddingFairs;
